/**
 * MealScheduleStep.constants.js
 *
 * Option data for Screen 10 "Meal Schedule". Breakfast/Lunch/Dinner are
 * required time-of-day values used to time-stamp meal cards on the final
 * plan; Bedtime is optional and drives the bedtime-snack/hydration
 * reminder. Number of Meals and Fasting Window are both optional — per
 * the FSD, when a fasting window is provided the Rule Engine compresses
 * meal slots accordingly (e.g. skips the bedtime snack for a 16:8
 * window), so the two aren't mutually exclusive but fastingWindow takes
 * precedence downstream when both are set.
 */

// Sensible defaults so the time pickers aren't blank on first render —
// formData still starts equal to these, so Next is enabled by default for
// the three required fields; the person can still change them.
export const DEFAULT_BREAKFAST_TIME = "08:00";
export const DEFAULT_LUNCH_TIME = "13:00";
export const DEFAULT_DINNER_TIME = "20:00";

// First entry is the unselected placeholder for each optional select,
// same required-select pattern as COOKING_TIME_OPTIONS in
// FoodPreferencesStep.constants.js — id "" means "not set" and is valid
// here since both fields are optional.
export const NUM_MEALS_OPTIONS = [
  { id: "", label: "No preference" },
  { id: "3", label: "3 meals a day" },
  { id: "4", label: "4 meals a day" },
  { id: "5", label: "5 meals a day" },
  { id: "6", label: "6 meals a day" },
];

// id is the stable value persisted to the assessment record and read by
// the Rule Engine to compress meal slots (e.g. "16_8" drops the bedtime
// snack slot).
export const FASTING_WINDOW_OPTIONS = [
  { id: "", label: "No fasting window" },
  { id: "12_12", label: "12:12" },
  { id: "14_10", label: "14:10" },
  { id: "16_8", label: "16:8" },
  { id: "18_6", label: "18:6" },
  { id: "20_4", label: "20:4" },
];

export const MEAL_SCHEDULE_INITIAL_DATA = {
  breakfast: DEFAULT_BREAKFAST_TIME,
  lunch: DEFAULT_LUNCH_TIME,
  dinner: DEFAULT_DINNER_TIME,
  bedtime: "",
  numMeals: "",
  fastingWindow: "",
};
